/* eslint-disable import/prefer-default-export */
import {
  customerPaymentResponse,
  payloadStripeDataMethodPayment,
  responseCreatePaymentIntent,
  responseCreateSetupIntent,
  responseEcommerceLinkGeneration,
  responseEcommerceLinkGenerationByProductCodeAndBillingCode,
} from 'interfaces/Ecommerce';
import api from 'services';

const path = 'ecommerce';

export const postCreatePaymentIntent = async (): Promise<responseCreatePaymentIntent> => {
  const response = await api.post<responseCreatePaymentIntent>(`${path}/createPaymentIntent`);
  return response.data;
};

export const postCreateSetupIntent = async (customerCpf: string): Promise<responseCreateSetupIntent> => {
  const response = await api.post<responseCreateSetupIntent>(`${path}/createSetupIntent`, {
    cpf: customerCpf,
  });
  return response.data;
};

export const postCreateCustomer = async (cpf: string): Promise<customerPaymentResponse> => {
  const response = await api.post<customerPaymentResponse>(`${path}/createCustomer`, {
    cpf,
  });
  return response.data;
};

export const postStripeDataPaymentMethod = async (payload: payloadStripeDataMethodPayment) => {
  const response = await api.post(`${path}/stripeData/methodPayment`, payload);
  return response.data;
};

export const getLinkGenerationByProductAndBillingCode = async (productCode: number, billingCode: number) => {
  const response = await api.get<responseEcommerceLinkGenerationByProductCodeAndBillingCode>(
    `${path}/generationLink/${productCode}/${billingCode}`,
  );
  return response.data;
};

export const getLinkGeneration = async () => {
  const response = await api.get<responseEcommerceLinkGeneration>(`${path}/generationLink`);
  return response.data;
};
